module.exports = __webpack_public_path__ + "src/img/autoCheckerOn.289d4bb7.svg";